import { without } from 'lodash';
import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { AgentFilter, SiteFilter, StatusFilter, TestFilter, TimeRangeFilter } from '../../filters';
import { ServiceTestPerformancePanel, TestLogPanel } from '../../panels';
import { orderedStatuses, gray } from '../../../utilities/StatusUtilities';
import PageActionsWithNg1DrillDown from '../../page-framework/page-header/PageActionsWithNg1DrillDown';

export const pageId = 'test-log';

const statuses = without(orderedStatuses, gray);

export default function AgentDetailPage() {
    return (
        <Page id={pageId}>
            <PageHeader
                title={t`Service Test Log`}
                actions={<PageActionsWithNg1DrillDown pageTitle={t`Service Test Log`} />}
            >
                <FilterContainer>
                    <TimeRangeFilter required options={{ realTime: true }} />
                    <TestFilter required />
                    <AgentFilter />
                    <SiteFilter />
                    <StatusFilter options={{ statuses }} />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <ServiceTestPerformancePanel />
                <TestLogPanel expandable flexHeight />
            </PanelContainer>
        </Page>
    );
}
